import * as defaults from '../theme/config.default.json'
import * as config from '../../theme/config.json'

const keys = Object.keys(defaults)

type ConfigCollection = { [key: string]: any }
type Configuration = { [dictionary: string]: ConfigCollection }
let fromDefaults = keys.reduce(
    (prev: Configuration, curr: string) =>
        Object.assign(
            prev,
            {
                [curr]: Object.assign(
                    defaults[curr],
                    config[curr] || {}
                )
            }
        ),
    {} as Configuration
)

const preppedConfig = Object.keys(config).filter(prop => keys.indexOf(prop) === -1)
    .reduce(
        (prev: Configuration, curr: string) => Object.assign(
            prev,
            {
                [curr]: config[curr]
            }
        ),
        fromDefaults
    )

export const CATALOG_ONLY = "catalog-only"
export const FULL = "full"

export const FROM_BASELINE = "from-baseline"
export const APPLY_OVER = "apply-over"

export const USER_CHOICE = 'user-choice'
export const GRID_VIEW = 'grid-view'
export const LIST_VIEW = 'list-view'

export const RELATIVE_QUANT = 'relative'
export const ABSOLUTE_QUANT = 'absolute'

export class ThemeConfig {
    private static _viewMode: string
    private static _itemsPerPage: number
    private static _hideInapplicableFacets = false

    /**
     * Returns the specified configuration setting from the specified section.
     */
    public static get<TConfig>(section: string, key:string): TConfig {
        return preppedConfig['default'][section] && preppedConfig['default'][section][key] as TConfig
    }

    /**
     * Returns the current view mode.
     */
    public static get viewMode(): string {
        if(!ThemeConfig._viewMode)
            return ThemeConfig._viewMode = ThemeConfig.get<string>('app', 'view-mode')
        return ThemeConfig._viewMode
    }

  public static get itemsPerPage(): number {
    if(!ThemeConfig._itemsPerPage)
      return ThemeConfig._itemsPerPage = ThemeConfig.get<number>('catalog', 'items-per-page')
    return ThemeConfig._itemsPerPage
  }

  public static get hideInapplicableFacets(): boolean {
    if(!ThemeConfig. _hideInapplicableFacets)
      return ThemeConfig. _hideInapplicableFacets = ThemeConfig.get<boolean>('catalog', 'hide-inapplicable-facets')
    return ThemeConfig. _hideInapplicableFacets
  }
}
